<template>
  <div class="app-single-topup-amount-selector">
    <b-form-row>
      <div class="topUp-amount-label">
        <slot name="lblSingleTopUp">Direktaufladung</slot>
      </div>
      <div class="topUp-amount-selector">
        <b-select
          name="amount"
          required
          v-model="amount"
          :options="availableAmounts"
        ></b-select>
      </div>
    </b-form-row>
  </div>
</template>

<script>
import preFilledInput from '@/mixins/preFilledInput'
import configBasedTopUpPrice from '@/mixins/configBasedTopUpPrice'
export default {
  name: 'EnterSingleTopUp',
  mixins: [
    preFilledInput('amount', 'defaultValue', 'single-top-up'),
    configBasedTopUpPrice
  ],
  props: {
    amounts: {
      type: Array,
      required: true
    },
    defaultAmount: {
      type: Number,
      default: 1000
    },
    singleTopUp: {
      type: Number
    }
  },
  computed: {
    defaultValue: function () {
      if (this.singleTopUp) {
        return this.singleTopUp
      }
      return this.defaultAmount
    },
    availableAmounts: function () {
      const me = this
      return this.amounts.map(cents => {
        return {
          value: cents,
          text: me.price(cents)
        }
      })
    }
  }
}
</script>
